import { createElement, useCallback, useEffect, useRef, useState } from 'react';
import { useEditor } from '@craftjs/core';
import { theme } from '@frontend/theme';
import { COMPOSER_BREAKPOINTS } from '../constants';
import { useContentComposer } from '../content-composer-provider';
import { Toolbox } from './toolbox';

export const Sidebar = () => {
  const { activePanel, setActivePanel } = useContentComposer();
  const [positionX, setPositionX] = useState(0);
  const [positionY, setPositionY] = useState(0);
  const containerRef = useRef<HTMLDivElement>(null);

  // TODO: Revisit this scroll down logic to close the toolbar panel
  const handleSwipe = useCallback((deltaX: number, deltaY: number) => {
    if (Math.abs(deltaX) < Math.abs(deltaY) && deltaY > 0) {
      setActivePanel('unset');
    }
  }, []);

  const handleTouchStart = useCallback((e?: TouchEvent) => {
    if (!containerRef?.current?.contains(e?.target as Node)) return;
    // e.preventDefault();
    if (e?.touches[0]) {
      setPositionX(e.touches[0].clientX);
      setPositionY(e.touches[0].clientY);
    }
  }, []);

  const handleTouchEnd = useCallback(
    (e?: TouchEvent) => {
      if (!containerRef?.current?.contains(e?.target as Node)) return;
      // e.preventDefault();
      const endX = e?.changedTouches[0]?.clientX;
      const endY = e?.changedTouches[0]?.clientY;
      if (!endX || !endY) return;
      const deltaX = endX - positionX;
      const deltaY = endY - positionY;
      handleSwipe(deltaX, deltaY);
    },
    [positionX, positionY, handleSwipe]
  );

  useEffect(() => {
    window.addEventListener('touchstart', handleTouchStart);
    window.addEventListener('touchend', handleTouchEnd);
    return () => {
      window.removeEventListener('touchstart', handleTouchStart);
      window.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleTouchStart, handleTouchEnd]);

  const { selectedSetting } = useEditor((state) => {
    const [currentNodeId] = state.events.selected;
    return {
      selectedSetting: currentNodeId ? state.nodes[currentNodeId]?.related?.settings : null,
    };
  });

  return (
    <aside
      className='content-composer-sidebar'
      css={{
        backgroundColor: theme.colors.white,
        borderRight: `solid 1px ${theme.colors.neutral20}`,
        display: 'flex',
        flexDirection: 'column',
        gap: selectedSetting ? 0 : theme.spacing(2),
        gridArea: 'sidebar',
        overflow: activePanel === 'settings' ? 'hidden' : 'hidden auto',
        position: 'relative',
        transition: 'transform 0.3s ease-in-out',

        [`@media (max-width: ${COMPOSER_BREAKPOINTS.DESKTOP}px)`]: {
          borderRight: 0,
          boxShadow: theme.shadows.floating,
          bottom: 0,
          height: '40%',
          left: 0,
          position: 'absolute',
          transform: activePanel !== 'unset' ? 'translateY(0)' : 'translateY(100%)',
          width: '100%',
          zIndex: theme.zIndex.high,
        },
      }}
      ref={containerRef}
    >
      {selectedSetting ? createElement(selectedSetting) : <Toolbox />}
    </aside>
  );
};
